/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["nz-card[_ngcontent-%COMP%]{border:none;padding:20px;box-shadow:2px 2px 4px rgba(0,0,0,.1)}[_nghost-%COMP%]     .ant-card-body{padding:0}.title[_ngcontent-%COMP%]{font-size:20px;color:#394042}.description[_ngcontent-%COMP%]{margin:0;font-size:14px;color:#8e8fa6}.margin-top-6[_ngcontent-%COMP%]{margin-top:6px}"];
export { styles as styles };
